module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Water.95319cd6.png";